import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Component from "./component";
import withOtp from "../../shared/with-otp";
import { saveCustomerReview } from "./actions";

const mapStateToProps = ({
    user: { isLoggedIn, secureToken, name }
}) => ({
    isLoggedIn,
    secureToken,
    name
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    saveCustomerReviewConnect: saveCustomerReview
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withOtp(Component)));
